import React from 'react';
import { Creatable } from 'react-select';
import 'react-select/dist/react-select.css';

class SelectCreatableListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            clearable: true,
            selectValue: '',
            textCreator: 'Search for ',
        }
    }

    c = (input) => {
        return ("Search for " + input)
    };

    render() {
        let {disabled, clearable} = this.state;
        let {data, valueKey, textField, selectValue, onValueChange, multiSelectMode, placeholder, promptText} = this.props;
        promptText = (promptText) ? promptText : 'Search for ';

        multiSelectMode = (multiSelectMode !== undefined);
         return (
            <div>
                <Creatable placeholder={placeholder} promptTextCreator={(input) => promptText + input } options={data} multi={multiSelectMode} labelKey={textField} valueKey={valueKey} autfocus clearable={clearable} disabled={disabled}
                           value={selectValue} onChange={onValueChange}/>
            </div>
        )

    }
}




export default SelectCreatableListComponent;



// WEBPACK FOOTER //
// ./src/views/utils/selectCreatableList.js